export const getPricingTitleInternal = () => {
	return 'Jira Service Management Pricing Page';
};
